package diana.soleil.design.iraniancanadienbazzar.core.common

// navigator.language is e.g. "en-US"/"fr-CA"; take the language subtag (dependency-free JS interop).
actual fun deviceLanguageCode(): String? =
    (js("navigator.language") as? String)?.substringBefore('-')?.ifBlank { null }
